import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { metricsDetails } from '@/constants';
import { MetricType } from '@/constants/metric-type.enum';
import { toTranslationFormat } from '@/utils/util-functions';

import CustomGauge from './CustomGauge';

interface MetricMonitorCustomGaugeProps {
  entity: {
    index: number;
    deviceId: string;
    metric: MetricType;
    upperThreshold?: number;
    lowerThreshold?: number;
  };
}

const metricsWithNoName: MetricType[] = [
  MetricType.PressureBar,
  MetricType.FlowM3Min,
  MetricType.PowerKw,
  MetricType.CurrentAmp,
  MetricType.TempCelsius,
  MetricType.DewpointTemperatureCelsius,
  MetricType.ValveAction,
];

const MetricMonitorCustomGauge = observer(({ entity }: MetricMonitorCustomGaugeProps) => {
  const { deviceId, metric, upperThreshold, lowerThreshold } = entity;
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { currentStation } = stationStore;
  const device = currentStation.devices.find(device => device.deviceId === deviceId);

  if (!device) {
    return null;
  }

  const getTitle = () => {
    return metricsWithNoName.includes(metric)
      ? device.name
      : `${t(toTranslationFormat(metricsDetails[metric]?.text))} ${device.name}`;
  };

  const getValue = () => {
    return device === undefined && device[metric] === undefined ? '--' : device[metric];
  };

  const getUnit = () => {
    return metricsDetails[metric]?.unit;
  };

  return (
    <CustomGauge
      title={getTitle()}
      value={getValue()}
      unit={getUnit()}
      lowerThreshold={lowerThreshold}
      upperThreshold={upperThreshold}
    />
  );
});

export default MetricMonitorCustomGauge;
